var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-panel"},[_c('img',{attrs:{"src":_vm.emptyImage}}),_c('p',{staticClass:"mt-3"},[_vm._v("\n    "+_vm._s(_vm.$i18nPresenter.t('Great! You’re on point!'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }